import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faNetworkWired,
    faUser,
    faGlobe,
    faClock
} from "@fortawesome/free-solid-svg-icons";

import CircularProgress from "../CircularProgress";
import { useDevice } from "./DeviceContext";

export default function DeviceHeader() {
    const { device, metrics = {} } = useDevice();

    // Metrics Safe Fallbacks
    const cpu = metrics?.cpu ?? 0;
    const memory = metrics?.memory ?? 0;
    const uptime = metrics?.uptime || "N/A";
    const deviceInfo = metrics?.device_info || {};

    return (
        <header className="main-header">
            <div className="brand">
                <FontAwesomeIcon icon={faNetworkWired} />
                <span>OLT Dashboard</span>
            </div>

            <div className="user-info">
                <span>
                    <FontAwesomeIcon icon={faUser} /> Admin
                </span>
                <span>
                    <FontAwesomeIcon icon={faGlobe} /> {device?.ip_address || "N/A"}
                </span>
                {deviceInfo?.vendor && (
                    <span className="vendor">{deviceInfo.vendor}</span>
                )}
            </div>

            <div className="header-metrics-group">
                {/* CPU Gauge */}
                <div className="gauge-item">
                    <CircularProgress percentage={cpu} color="#4caf50" />
                    <p>CPU {cpu}%</p>
                </div>

                {/* Device Specs Center */}
                <div className="device-spec-center">
                    <h3>{deviceInfo?.model || "N/A"}</h3>
                    <p>MAC : {deviceInfo?.mac || "N/A"}</p>
                    <p>SN : {deviceInfo?.sn || "N/A"}</p>
                </div>

                {/* RAM Gauge */}
                <div className="gauge-item">
                    <CircularProgress percentage={memory} color="#f44336" />
                    <p>RAM {memory}%</p>
                </div>

                {/* Uptime */}
                <div className="uptime-info">
                    <FontAwesomeIcon icon={faClock} /> {uptime}
                </div>
            </div>
        </header>
    );
}